import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NewContactComponent } from '../new-contact/new-contact.component';
import _ from 'lodash';
import { gridPageRequest, gridPagination } from '../../../../model/common/common.model';
import { contact, contactGridResponse } from '../../../../model/contact/contact.model';
import { SharedModule } from '../../../../shared/shared.module';
import { ContactService } from '../../../../services/contact.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-contact-list',
  standalone: true,
  imports: [SharedModule, CommonModule],
  providers: [DialogService],
  templateUrl: './contact-list.component.html',
  styleUrl: './contact-list.component.scss'
})



export class ContactListComponent implements OnInit {

  @Input() customerId: any;
  @Input() salespersonId: any;
  @Input() vendorId: any;
  loader: boolean = false;
  selectedContact: contact[] = [];
  result: contactGridResponse = {
    contacts: [],
    totalRecords: 0
  }
  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 0
  }
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }
  constructor(private contactService: ContactService, private messageService: MessageService, private ContactServices: ContactService, private confirmationService: ConfirmationService, public dialogService: DialogService, private route: Router) { }

  ref: DynamicDialogRef = new DynamicDialogRef;

  ngOnInit(): void {
    this.pageRequest.pageSize = 5;

    if (this.customerId) {
      this.pageRequest.id = this.customerId;
      this.getContacts(this.pageRequest);
    } else if (this.salespersonId) {      // created by Prajakta on date 07/06/2024. created for contact added for the salesperson -->
      this.pageRequest.id = this.salespersonId;
      this.getSalespersonContacts(this.pageRequest);
    } else if (this.vendorId) {
      this.pageRequest.id = this.vendorId;
      this.getVendorContacts(this.pageRequest);
    }
  }

  showContact() {
    this.ref = this.dialogService.open(NewContactComponent, {
      header: 'Create Contact',
      width: '80%',
      data: {
        customerId: this.customerId,
        salespersonId: this.salespersonId,
        vendorId: this.vendorId,
        contactDetails: this.result.contacts
      }
    });

    this.ref.onClose.subscribe((data: any) => {
      if (this.customerId) {
        this.getContacts(this.pageRequest);
      } else if (this.salespersonId) {
        this.getSalespersonContacts(this.pageRequest);
      } else if (this.vendorId) {
        this.getVendorContacts(this.pageRequest);
      }
    });

  }

  // createContact(data: any) {
  //   this.ContactServices.createContact(data).subscribe({
  //     next: (response: any) => {
  //       this.result.contacts.push(data);
  //       this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Contact saved successfully. ' });
  //     },
  //     error: error => {
  //       console.error('Error saving contact:', error);
  //     }
  //   });
  // }

  getContacts(query: gridPageRequest) {
    this.contactService.getContactByCustomer(query).subscribe(
      (data: any) => {
        this.result = data as contactGridResponse;
        this.pageCalculation();
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  pageCalculation() {
    // this.pageRequest.pageSize = this.rowsPerPage;
    let last = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + this.pageRequest.pageSize;
    this.gridPagination.first = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + 1;
    this.gridPagination.last = last < this.result.totalRecords ? last : this.result.totalRecords;
    this.gridPagination.totalRecords = this.result.totalRecords;
    // this.paginationLabel = _.toString(this.pageRequest.pageIndex * this.pageRequest.pageSize) + (this.result.)
  }

  onPrevious() {
    this.pageRequest.pageIndex = this.pageRequest.pageIndex - 1;
    this.getContacts(this.pageRequest);
    this.getSalespersonContacts(this.pageRequest);
    this.getVendorContacts(this.pageRequest);
  }

  onNext() {
    this.pageRequest.pageIndex = this.pageRequest.pageIndex + 1;
    this.getContacts(this.pageRequest);
    this.getSalespersonContacts(this.pageRequest);
    this.getVendorContacts(this.pageRequest);

  }

  editContact() {
    const contactId = this.selectedContact[0].contactId;
    this.ref = this.dialogService.open(NewContactComponent, {
      header: 'Edit Contact',
      width: '80%',
      data: { contactId: contactId, customerId: this.customerId, salespersonId: this.salespersonId, vendorId: this.vendorId, contactDetails: this.result.contacts }
    });

    this.ref.onClose.subscribe((data: any) => {
      this.selectedContact = [];
      if (this.customerId) {
        this.getContacts(this.pageRequest);
      } else if (this.salespersonId) {
        this.getSalespersonContacts(this.pageRequest);
      } else if (this.vendorId) {
        this.getVendorContacts(this.pageRequest);
      }
    });
  }


  deleteContact() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;

        if (this.selectedContact && this.selectedContact.length > 0) {
          var contactIds = _.map(this.selectedContact, 'contactId');
          var isVendorContact = this.selectedContact.every(contact => contact.vendorId);
          var isSalespersonContact = this.selectedContact.every(contact => contact.salespersonId);
          this.contactService.deleteContact(contactIds).subscribe({
            next: data => {
              this.selectedContact = [];
              this.loader = false;
              if (isVendorContact) {
                this.getVendorContacts(this.pageRequest);
              } else if (isSalespersonContact) {
                this.getSalespersonContacts(this.pageRequest);
              }
              else {
                this.getContacts(this.pageRequest);
              }
            },
            error: error => {
              console.log(error);
              this.loader = false;
            }
          });
        }
      },
      reject: () => {
        // User canceled deletion
      }
    });
  }


  /** created by shyam on 31/05/2024
   * Loads more contacts on pagination.
   * Increases `pageSize` by `event.first + 5` and fetches data.
   */
  loadContacts(event: any) {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getContacts(this.pageRequest);
    this.getSalespersonContacts(this.pageRequest);
    this.getVendorContacts(this.pageRequest);

  }
  // created by Prajakta on date 07/06/2024. created for contact added for salesperson
  refreshContacts() {
    this.getContacts(this.pageRequest);
    this.getSalespersonContacts(this.pageRequest);
    this.getVendorContacts(this.pageRequest);
  }


  getSalespersonContacts(query: gridPageRequest) {
    this.contactService.getContactBySalesperson(query).subscribe(
      (data: any) => {
        this.result = data as contactGridResponse;
        this.pageCalculation();
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getVendorContacts(query: gridPageRequest) {
    this.contactService.getContactByVendor(query).subscribe(
      (data: any) => {
        this.result = data as contactGridResponse;
        this.pageCalculation();
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

}
